<template>
  <a-modal :title="title" :width="800" :visible="visible" :confirmLoading="confirmLoading" switchFullscreen
    @ok="handleOk" @cancel="handleCancel" cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{ labelCol: { span: 4 }, wrapperCol: { span: 14 }, }"
        ref="ruleForm" :rules="rules">

        <a-form-model-item prop="name" label="亚专业名称">
          <a-input placeholder="请输入亚专业名称" v-model="model.name" :disabled="model.id"  />
        </a-form-model-item>

        <a-form-model-item prop="icon" label="亚专业图标">
          <a-input placeholder="请输入亚专业图标" v-model="model.icon" />
        </a-form-model-item>


        <a-form-model-item prop="icon" label="关联科室">
          <div class='header'><a-button @click="addDept" type="primary" size='small' style='float: right'>添加</a-button>
          </div>
          <div class='list' v-if="model.deptSelectList">
            <div class='list-item' v-for='(item, index) in model.deptSelectList'>
              <a-space :size='12'>
                <a-select style='width: 300px' v-model='item.id' @change="source2Change(item)"  placeholder='请选择' allow-clear showSearch :filterOption="filterOption">
                  <a-select-option :value='item.id' :key="item.id" v-for="item in deptList">{{ item.name}}</a-select-option>
                </a-select>
                <span><a-icon type="close" @click='removeDataSource(index)' /></span>
              </a-space>
            </div>
          </div>
        </a-form-model-item>

        <a-form-model-item prop="enabled" label="是否启用">
          <a-radio-group v-model="model.enabled">
            <a-radio-button value="0">
              否
            </a-radio-button>
            <a-radio-button value="1">
              是
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item prop="keyword" help="输入关键字后，敲击回车键" label="关键字">
          <a-select mode="tags" @change="keywordChange" v-model='model.keywordList' placeholder='请选择'>
            <a-select-option :value='item' :key="item" v-for="item in model.keywordList">{{ item }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="description" label="描述">
          <a-textarea :rows="4" placeholder="请输入描述" v-model="model.description" />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import baseRules from '@/constants/baseRules'

export default {
  name: "TempConfigSubMajorModal",
  data() {
    return {
      title: "操作",
      visible: false,
      model: {
        keywordList: [],
        deptSelectList: []
      },
      rules: {
        name: [baseRules.required],
        code: [baseRules.required],
        keywordList: [baseRules.requiredChange],
      },
      confirmLoading: false,
      deptList: [],
      pointList: [],
      url: {
        add: "/tempconfig/tempConfigSubmajor/add",
        edit: "/tempconfig/tempConfigSubmajor/edit",
      },
    }
  },
  created() {
    getAction('/tempconfig/tempConfigDept/listAll').then(res => {
      if (res.success) {
        this.deptList = res.result
      }
    })
  },
  methods: {
    keywordChange() {
      this.$set(this.model, 'keyword', this.model.keywordList.join(','))
    },

    add() {
      this.edit({
        enabled: '1',
        keywordList: [],
        deptSelectList: [],
      });
    },
    edit(record) {
      this.model = Object.assign({
        keywordList: record.keyword ? record.keyword.split(',') : [],
        deptSelectList: record.deptSelectList,
        icon: record.icon,
      }, record);
      this.visible = true;
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'put';
          }
          let formData = this.model;
          httpAction(httpurl, formData, method).then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok');
            } else {
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
            that.close();
          })
        } else {
          return false;
        }
      })
    },
    handleCancel() {
      this.close()
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    addDept() {
      const dataSource2 = this.model.deptSelectList || []
      dataSource2.push({id: ''})
      this.$set(this.model, 'deptSelectList', dataSource2)
    },
    source2Change(item) {
      const field = this.deptList.filter(field => field.id === item.id)[0]
      if (field) {
        item.name = `${field.name}`
      }
    },
    /**
     * 移除数据源
     * @param key
     * @param index
     */
     removeDataSource(index) {
      this.model.deptSelectList.splice(index, 1)
    },
  }
}
</script>

<style lang="less" scoped>
.list>.list-item {
  margin: 12px auto;
  width: 1200px;
}
</style>